// extracted by mini-css-extract-plugin
module.exports = {"localeIcon":"_3r5F3","displayIcon":"_1zYo7","optionIcon":"JmRSI","selectLanguage":"_2ZP4j","optionContent":"_1Yteu","container":"_1C5GS"};